import { AbstractModel } from '@/models/base';
import {
  IQuestionTag,
  IQuestionTagData,
  ITag,
  ITagData
} from './question-tag.types';

export class Tag extends AbstractModel implements ITag {
  readonly id?: number;

  readonly name: string;
  readonly is_label_required: boolean = false;

  constructor(data: ITagData) {
    super();

    const requiredFields: (keyof ITagData)[] = ['name'];
    this.validate(data, requiredFields);

    if (data.id) {
      this.id = data.id;
    }

    this.name = data.name!;

    if (data.is_label_required) {
      this.is_label_required = data.is_label_required;
    }
  }

  toString(): string {
    return this.name;
  }
}

export class QuestionTag extends AbstractModel implements IQuestionTag {
  readonly id?: number;
  readonly label: string = '';
  readonly tag: ITag | number;

  constructor(data: IQuestionTagData) {
    super();

    const requiredFields: (keyof IQuestionTagData)[] = ['tag'];

    this.validate(data, requiredFields);
    if (data.id) {
      this.id = data.id;
    }

    this.tag = typeof data.tag === 'number' ? data.tag : new Tag(data.tag!);

    if (data.label) {
      this.label = data.label;
    }
  }

  toString(): string {
    let str = this.tag.toString();
    if (this.label) {
      str += ` - ${this.label}`;
    }
    return str;
  }
}
